import { useState } from 'react';
import { SortWidget } from './SortWidget';

const useSortWidget = ({
  defaultValue,
  sortOptions,
  size = 'regular',
}: {
  defaultValue: string;
  sortOptions: string[];
  size?: 'small' | 'regular';
}) => {
  const [sortBy, setSortBy] = useState(defaultValue);

  // Convert string[] to SortOption[] for backwards compatibility
  const options = sortOptions.map((option) => ({ label: option, value: option }));

  const SortWidgetElement = (
    <SortWidget value={sortBy} onChange={setSortBy} options={options} size={size} />
  );

  return { SortWidget: SortWidgetElement, sortBy };
};

export default useSortWidget;
